export default "__VITE_ASSET__azPgnOK8__"